<template>
  <div>
    <button
      type="button"
      class="btn btn-sm btn-block d-flex justify-content-center align-items-center button-wishlist"
      :class="{ 'btn-primary-link': !isOnWishlist }"
      @click="clickHandler"
    >
      <div
        v-if="isLoading"
        class="spinner-border spinner-border-sm text-primary spinner-thin"
      ></div>
      <i
        v-else
        class="icon i-6"
        :class="{ 'icon-heart-filled': isOnWishlist, 'icon-heart': !isOnWishlist }"
      ></i>
      <span class="text-xs pl-1">
        {{ isOnWishlist ? translations["on_wishlist"] : translations["add"] }}
      </span>
    </button>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  props: {
    translations: {
      required: true,
      type: Object,
    },
    createWishUrl: {
      required: true,
      type: String,
    },
    productOnWishlist: {
      type: Boolean,
      default: false,
    },
    wishlistUrl: {
      required: true,
      type: String,
    },
  },
  data() {
    return {
      isOnWishlist: this.productOnWishlist,
      isLoading: false,
    };
  },
  methods: {
    ...mapActions({ flash: "flashMessages/flash" }),
    clickHandler() {
      if (this.isOnWishlist) {
        this.redirectToWishlist();
      } else {
        this.putOnWishlist();
      }
    },
    putOnWishlist() {
      this.isLoading = !this.isLoading;
      this.axios
        .put(this.createWishUrl, { format: "json" })
        .then(response => {
          this.isOnWishlist = true;
          this.flash({ type: "notice", message: response.data.notice });
        })
        .catch(() => {
          this.flash({ type: "error", message: this.translations["error"] });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    redirectToWishlist() {
      window.location.assign(this.wishlistUrl);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~styles/global";

.spinner-thin {
  border-width: 0.15em;
}

.button-wishlist {
  min-height: 3rem;
}
</style>
